const option_enabled = [
  { label: "啟用", value: 1 },
  { label: "停用", value: 0 },
];

const option_yesno = [
  { label: "是", value: 1 },
  { label: "否", value: 2 },
];

const option_finish = [
  { label: "完成", value: 1 },
  { label: "未完成", value: 0 },
];

const option_member_type = [
  { label: "面試人員", value: 1 },
  { label: "在職人員", value: 2 },
  { label: "離職人員", value: 3 },
];

const option_marriage = [
  { label: "已婚", value: 1 },
  { label: "未婚", value: 2 },
  { label: "離婚", value: 3 },
  { label: "喪偶", value: 4 },
];

const option_military_service = [
  { label: "役畢", value: 1 },
  { label: "未役", value: 2 },
  { label: "無需服役", value: 3 },
];

const option_blood_type = [
  { label: "A", value: 1 },
  { label: "B", value: 2 },
  { label: "AB", value: 3 },
  { label: "O", value: 4 },
];

const option_isgraduation = [
  { label: "畢業", value: 1 },
  { label: "肄業", value: 2 },
];

const option_language_type = [
  { label: "聽", value: 1 },
  { label: "說", value: 2 },
  { label: "讀", value: 3 },
  { label: "寫", value: 4 },
];

const option_language_level = [
  { label: "精通", value: 1 },
  { label: "中等", value: 2 },
  { label: "略懂", value: 3 },
  { label: "不會", value: 4 },
];

const option_salary_type = [
  { label: "本薪", value: 1 },
  { label: "交通津貼", value: 2 },
  { label: "全勤獎金", value: 3 },
  { label: "職務/技術", value: 4 },
];

const option_award = [
  { label: "嘉獎", value: 1 },
  { label: "小功", value: 2 },
  { label: "大功", value: 3 },
];

const option_punish = [
  { label: "警告", value: 1, score: 3 },
  { label: "小過", value: 2, score: 6 },
  { label: "大過", value: 3, score: 10 },
  { label: "遲到扣分", value: 4, score: 2 },
  // { label: "早退", value: 5, score: 2 },
  // { label: "曠職", value: 6, score: 10 },
];

const option_leave_work = [
  { label: "特休假", value: "特休假" },
  { label: "公假", value: "公假" },
];

const option_season = [
  { label: 1, value: 1 },
  { label: 2, value: 2 },
  { label: 3, value: 3 },
  { label: 4, value: 4 },
];

const option_symptoms = [
    { key: "u5", label: "頭昏腦脹/頭暈/眩暈/暈厥感", value: 5, width: 17 },
    { key: "u12", label: "耳鳴", value: 12, width: 10 },
    { key: "u1", label: "胸悶/胸痛", value: 1, width: 13 },
    { key: "u8", label: "心悸", value: 8, width: 10 },
    { key: "u2", label: "呼吸喘", value: 2, width: 10 },
    { key: "u3", label: "呼吸困難", value: 3, width: 12 },
    { key: "u9", label: "消化不良感", value: 9, width: 15 },
    { key: "u10", label: "食慾下降", value: 10, width: 12 },
    { key: "u11", label: "噁心/嘔吐", value: 11, width: 13 },
    { key: "u13", label: "手/腳痲", value: 13, width: 12 },
    { key: "u4", label: "冒冷汗", value: 4, width: 10 },
    { key: "u6", label: "疲倦/無力", value: 6, width: 13 },
    { key: "u7", label: "不正常害怕/焦慮", value: 7, width: 19 },
    { key: "u14", label: "其他", value: 14, width: 30 },
  ],
  option_symptoms_obj = option_symptoms.reduce(
    (pre, cur) => ({ ...pre, [cur.key]: cur }),
    {}
  );

const option_dangerous_eat_type = [
    { key: "r8_1", label: "高鹽", value: 1 },
    { key: "r8_2", label: "高糖", value: 2 },
    { key: "r8_3", label: "高油", value: 3 },
    { key: "r8_4", label: "高熱量", value: 4 },
  ],
  option_dangerous = [
    // { key: "r1", label: "早發冠心病家族史", value: 1 },
    { key: "r2", label: "糖尿病", value: 2 },
    { key: "r3", label: "高血壓", value: 3 },
    { key: "r4", label: "高脂血症/高膽固醇血症", value: 4 },
    { key: "r5", label: "抽菸", value: 5 },
    { key: "r6", label: "二手菸", value: 6 },
    { key: "r7", label: "過量飲酒", value: 7 },
    { key: "r8", label: "不當飲食", value: 8 },
    { key: "r9", label: "缺乏運動", value: 9 },
    { key: "r10", label: "壓力", value: 10 },
    { key: "r11", label: "肥胖", value: 11 },
    { key: "r12", label: "其他", value: 12 },
  ],
  option_dangerous_obj = [
    ...option_dangerous,
    ...option_dangerous_eat_type,
  ].reduce((pre, cur) => ({ ...pre, [cur.key]: cur }), {});

const option_period_time = [
    { label: "早上", value: 1 },
    { label: "下午", value: 2 },
    { label: "晚上", value: 3 },
  ],
  option_period_time_obj = option_period_time.reduce(
    (pre, cur) => ({ ...pre, [cur.value]: cur }),
    {}
  );

const option_measure_time = [
    { label: "飯前", value: 1 },
    { label: "飯後", value: 2 },
    { label: "睡前", value: 3 },
  ],
  option_measure_time_obj = option_measure_time.reduce(
    (pre, cur) => ({ ...pre, [cur.value]: cur }),
    {}
  );

const option_warn_limit = {
  systolic_blood_pressure: { down: 90, up: 129.999999 },
  diastolic_blood_pressure: { down: 60, up: 79.999999 },
  heart_rate: { down: 60, up: 100 },
  bmi: { down: 18.5, up: 29.999999 },
  glucose: { down: 70, up: 179.999999 },
};

const option_category = {
    setting: [
      { label: "基本資料", value: "profile" },
      { label: "危險因素評估", value: "dangerous" },
      { label: "個人目標", value: "work" },
      { label: "隱私權及網站安全政策與個資安全聲明", value: "privacy" },
      // { label: "個資安全聲明", value: "security" },
      { label: "使用說明", value: "manual" },
      { label: "常見問題", value: "qa" },
    ],
    record: [
      {
        label: "血壓/心跳​",
        value: "heartbeat",
        apiKey: "heartbeat_blood_pressure",
        type: 1,
      },
      {
        label: "血糖",
        value: "sugar",
        apiKey: "glucose",
        type: 2,
      },
      { label: "體重", value: "weight", apiKey: "weight", type: 3 },
      {
        label: "不適症狀",
        value: "uncomfortable",
        apiKey: "uncomfortable_symptoms",
        type: 4,
      },
      {
        label: "健康行為",
        value: "health",
        apiKey: "health_behavior",
        type: 5,
      },
    ],
    knowledge: [
      { label: "疾病", value: "disease", type: 1 },
      { label: "飲食", value: "diet", type: 2 },
      { label: "運動", value: "exercise", type: 3 },
      { label: "紓壓", value: "express", type: 4 },
      { label: "香菸與環境", value: "environment", type: 5 },
      { label: "藥物", value: "medicine", type: 6 },
      { label: "自我測量", value: "measure", type: 7 },
    ],
  },
  option_category_obj = Object.entries(option_category).reduce(
    (preMain, [curCategory, categoryData]) => ({
      ...preMain,
      [curCategory]: categoryData.reduce(
        (pre, cur) => ({ ...pre, [cur.value]: cur }),
        {}
      ),
    }),
    {}
  );

export const errorRecordMsg =
  "您的記錄數值異常\n請確認是否正確\n必要時諮詢專業人員";

const option_colData = [
  "AE8799",
  "5B618A",
  "717EC3",
  "BCE7FD",
  "C492B1",
  "424651",
  "21FA90",
  "E9D758",
  "297373",
  "FF8552",
  "E6E6E6",
  "F7D08A",
  "E3F09B",
  "87B6A7",
  "F79F79",
  "5B5941",
  "5B507A",
  "496DDB",
  "EE8434",
  "C95D63",
];

const option_system_startYear = 2024;

const option_link_type = [
  { label: "Youtube", value: 1 },
  { label: "PDF", value: 2 },
  { label: "連結", value: 3 },
];

const option_hours = [...Array(24).keys()].map((item) => ({
  label: String(item).length === 1 ? `0${item}` : String(item),
  value: String(item).length === 1 ? `0${item}` : String(item),
}));
const option_minutes = [...Array(60).keys()].map((item) => ({
  label: String(item).length === 1 ? `0${item}` : String(item),
  value: String(item).length === 1 ? `0${item}` : String(item),
}));

const option_date_range = [
    { label: "1週", value: 1, diffType: "days", diffValue: 7 },
    { label: "1個月", value: 2, diffType: "months", diffValue: 1 },
    { label: "2個月", value: 3, diffType: "months", diffValue: 2 },
    { label: "3個月", value: 4, diffType: "months", diffValue: 3 },
    { label: "自訂", value: 5 },
  ],
  option_date_range_obj = option_date_range.reduce(
    (pre, cur) => ({ ...pre, [cur.value]: cur }),
    {}
  );

export {
  option_enabled,
  option_yesno,
  option_finish,
  option_member_type,
  option_marriage,
  option_military_service,
  option_blood_type,
  option_isgraduation,
  option_language_type,
  option_language_level,
  option_salary_type,
  option_award,
  option_punish,
  option_season,
  option_symptoms,
  option_symptoms_obj,
  option_dangerous_eat_type,
  option_dangerous,
  option_dangerous_obj,
  option_period_time,
  option_period_time_obj,
  option_measure_time,
  option_measure_time_obj,
  option_leave_work,
  option_system_startYear,
  option_warn_limit,
  option_category,
  option_category_obj,
  option_colData,
  option_link_type,
  option_hours,
  option_minutes,
  option_date_range,
  option_date_range_obj,
};
